import React from 'react';
import ClassAssembly  from 'views/ClassAssembly10C';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;